














































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import QRCode from "qrcode";
import {tools} from "@/util/tools";
import {resolveDeviceContext} from "@/util/deviceContext";
import {accentAlpha} from "@/util/accentColor";

type InstallTab = "automatic" | "scanQr" | "manual";

// The teal tint the design originally hardcoded behind the one-tap glyph, kept as the
// fallback for a non-hex accent colour.
const DEFAULT_ICON_TINT = "#E6F2F1";

@Component
export default class EsimInstallMethodsCard extends Vue {
    @Prop({required: true}) accentColor!: string;
    @Prop({required: true}) iccid!: string;
    @Prop({required: true}) encodedActivationCode!: string;
    @Prop({default: null}) smdpPlusAddress!: string | null;
    @Prop({default: null}) activationCode!: string | null;
    @Prop({required: true}) appleUniversalLink!: string;
    @Prop({required: true}) androidUniversalLink!: string;

    // One-tap only works on the device being installed on, so it is a poor landing tab when we
    // cannot tell what that device is - a desktop visitor is here to scan the code with a phone.
    private activeTab: InstallTab = resolveDeviceContext().os === "unknown" ? "scanQr" : "automatic";

    get isKnownMobileDevice(): boolean {
        const context = resolveDeviceContext();
        return context.isIOS || context.isAndroid;
    }

    // Only meaningful once isKnownMobileDevice is true; otherwise both links are offered instead.
    get oneTapInstallLink(): string {
        return resolveDeviceContext().isIOS ? this.appleUniversalLink : this.androidUniversalLink;
    }

    get methodIconStyle(): Record<string, string> {
        return {backgroundColor: accentAlpha(this.accentColor, 0.1, DEFAULT_ICON_TINT)};
    }

    get pageUrl(): string {
        return window.location.href;
    }

    mounted() {
        if (!this.encodedActivationCode) return;
        QRCode.toCanvas(
            this.$refs.qrCode,
            this.encodedActivationCode,
            {width: (this.$refs.qrCode as HTMLCanvasElement).width, margin: 0},
            (error: any) => {
                if (error) console.error("Failed rendering QR code: ", error);
            }
        );
    }

    public async copy(code: string) {
        await tools.copyToClipboard(code);
        this.$toastr.success(this.$t("esimInstallation.success.codeCopied"), true, true);
    }

    public async copyPageUrl() {
        await tools.copyToClipboard(this.pageUrl);
        this.$toastr.success(this.$t("esimInstallation.success.urlCopied"), true, true);
    }
}
